import { RAFFLE } from "@/lib/raffleData";

const pad = (n) => String(n).padStart(4, "0");

const money = (n) =>
  new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n || 50000);

function receiptUrl(sale) {
  const ficha = pad(sale.ficha_number);
  // Use configured public URL if available; otherwise the current origin
  const base = process.env.REACT_APP_PUBLIC_URL || (typeof window !== "undefined" ? window.location.origin : "");
  return `${base}/comprobante/${ficha}`;
}

export function buildReceiptMessage(sale) {
  const url = receiptUrl(sale);
  return [
    "🎟️ *¡COMPRA EXITOSA — BETMAR!*",
    "",
    `Ficha: *#${pad(sale.ficha_number)}*`,
    `Comprador: ${sale.buyer_name || "-"}`,
    `Valor: ${money(sale.amount)}`,
    `Pago: ${sale.payment_method || "-"}`,
    "",
    "👉 Mira y descarga tu comprobante oficial:",
    url,
    "",
    `📅 Sorteo: ${RAFFLE.drawDate} (${RAFFLE.drawDateNote})`,
    `💵 Entrega anticipada $${RAFFLE.earlyPrize} el ${RAFFLE.earlyDate} (${RAFFLE.earlyDateNote}).`,
    "",
    "¡Gracias por participar! Conserva este link, es tu respaldo.",
  ].join("\n");
}

export function receiptLink(sale) {
  let phone = String(sale.buyer_phone || "").replace(/\D/g, "");
  if (phone.length === 10) phone = "57" + phone; // Colombia default
  const base = phone ? `https://wa.me/${phone}` : "https://wa.me/";
  return `${base}?text=${encodeURIComponent(buildReceiptMessage(sale))}`;
}

export function openReceipt(sale) {
  window.open(receiptLink(sale), "_blank", "noopener,noreferrer");
}
